import React from "react";
import {
  GSItemList,
  defaultBorders,
  defaultPadding,
  golfstatusColors,
} from "golfstatus_react_components";
import TournamentOrderFormResponseItem from "./tournament-order-form-response-item";

const cardStyle = {
  ...defaultPadding.xLargePad,
  ...defaultBorders.mediumLargeBorderRadius,
  backgroundColor: golfstatusColors.grey100,
  cursor: "pointer",
};

const TournamentOrderFormResponsesCard = (props) => {
  const { forms, onSelect } = props;

  return (
    <tournament-order-form-responses-card style={{ display: "block" }}>
      <div className="form-responses-card" onClick={onSelect} style={cardStyle}>
        <GSItemList
          type="vertical large-gap"
          items={forms ?? []}
          listItem={(item) => <TournamentOrderFormResponseItem {...item} />}
        />
      </div>
    </tournament-order-form-responses-card>
  );
};

export default TournamentOrderFormResponsesCard;
